// React
import { useState, useCallback, useEffect } from 'react';

// Amplify UI
import '@aws-amplify/ui-react/styles.css';
import {
    Button,
    Input,
    CheckboxField,
    Flex,
    Heading,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Label,
} from '@aws-amplify/ui-react';
import { callBackend } from './api.js';

function SetDetails({currentExercise, updateExercise}) {
    var current = currentExercise;
    if (current === undefined || current.sets === undefined) {
        return "";
    } else {
        return current.sets.map((i) => {
            return (
                <TableRow key={i.key}>
                    <TableCell>
                        <Input 
                            value={i.weight} 
                            key={i.key*200}
                            type="number" 
                            isRequired 
                            size="small"
                            style={
                                {
                                    maxWidth: "100px"
                                }
                            }
                            onChange={(event) => {
                                updateExercise("weight",i.key,event.target.value);
                            }}
                        />
                    </TableCell>
                    <TableCell>
                        <Input 
                            value={i.reps} 
                            key={i.key*100}
                            type="number" 
                            isRequired 
                            size="small"
                            style={
                                {
                                    maxWidth: "100px"
                                }
                            }
                            
                            onChange={(event) => {
                                updateExercise("reps",i.key,event.target.value);
                            }}
                        />
                    </TableCell>
                    <TableCell>
                        <CheckboxField 
                            checked={i.sore} 
                            onChange={(event) => {
                                updateExercise("sore",i.key,event.target.checked);
                            }}
                        />
                    </TableCell>
                    <TableCell>
                        <CheckboxField 
                            checked={i.cheat} 
                            onChange={(event) => {
                                updateExercise("cheat",i.key,event.target.checked);
                            }}
                        />
                    </TableCell>
                </TableRow>
            );
        });
    }
}

export default function CaptureExercise({
    selectedExercise, setSelectedExercise, closeFn, mustSave, setMustSave, mustClose, setMustClose, currentExercise, setCurrentExercise, blankExercise
}) {
    const [changes, setChanges] = useState(false);

    const populateCurrentExercise = useCallback(async () => {
        console.log('in populateCurrentExercise', selectedExercise);
        if (selectedExercise === "") {
            setCurrentExercise(blankExercise());
        } else {
            const myInit = {
                today_exercise_name: selectedExercise
            };

            try {
                const apiResult = await callBackend("workouts", "GET", myInit);
                
                setCurrentExercise(await apiResult);
                setChanges(false);
            } catch (e) {
                alert(`Error refreshing transactions: ${e}`);
            }
        }
    }, [selectedExercise]);

    useEffect(() => {
        //console.log('in useEffect', dayOfWeek);
        populateCurrentExercise();
    }, [populateCurrentExercise, selectedExercise]);

    
    const update = (field, index, newValue) => {
        updateExercise(field, index, newValue);
    }
    
    function updateExercise(field, index, newValue) {
        var toUpdate = currentExercise;

        if (index < 0) {
            toUpdate = {...currentExercise, [field]: newValue};
        } else {
            let newSets = currentExercise.sets
            console.log('newSets', newSets);
            console.log('index', index);
            console.log('field', field);
            if (newValue.length > 1 && newValue.startsWith("0")) {
                newValue = newValue.substr(1);
            }
            newSets[index][field] = newValue;
            toUpdate = {...currentExercise, sets: newSets};
        }

        setCurrentExercise(toUpdate);
        setChanges(true);
    }

    async function submitExercise() {
        console.log('in submitExercise', currentExercise.ts, currentExercise.when);
        if (!changes) {
            console.log('not saving');
            return;
        }
        if (currentExercise.ts === undefined || currentExercise.ts === '') {
            currentExercise.ts = currentExercise.when;
        }
        const path = 'workouts/create';
        const myInit = {
            body: {
                exercise: selectedExercise,
                details: currentExercise,
            },
        };

        try {
            const apiResult = await callBackend(path, "POST", myInit);
            
        } catch (e) {
            alert(`Error saving exercise: ${e}`);
        }
        try {
            if (mustClose) {
                var newOrder = parseInt(currentExercise.order)+1;
                setSelectedExercise("");
                var newExercise = {...blankExercise(), order: newOrder};
                setCurrentExercise(newExercise);
                closeFn();
            }
        } catch (e) {
            alert(`Error refreshing goods: ${e}`);
        } finally {
            setChanges(false);
        }
    }

    useEffect(() => {
        submitExercise();
    }, [mustSave]);

    
    return (
        selectedExercise && selectedExercise !== "" &&
        
        <Flex direction="column" alignContent="center">
            <Flex justifyContent="center">
                <Heading level="3">
                    Capture a new workout for {selectedExercise}
                </Heading>
            </Flex>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <Label htmlFor="details">Details specific to this workout</Label>
                        </TableCell>
                        <TableCell>
                            <Input id="details" value={currentExercise.details} size="small"
                                onChange={(event) => {
                                    updateExercise("details",-1,event.target.value);
                                }}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                                <Label htmlFor="order">Order within today's workout</Label>
                        </TableCell>
                        <TableCell>
                            <Input id="order" value={currentExercise.order} type="number"
                                onChange={(event) => {
                                    updateExercise("order",-1,event.target.value);
                                }}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                                <Label>When performed</Label>
                        </TableCell>
                        <TableCell>
                            {new Date(currentExercise.ts * 1000).toLocaleString('en-UK', {
                                weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false
                            }).replace(',', '')}
                            <br />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Table highlightOnHover={true} variation="striped">
                <TableHead>
                    <TableRow>
                        <TableCell as="th">Weight</TableCell>
                        <TableCell as="th">Reps</TableCell>
                        <TableCell as="th">Sore</TableCell>
                        <TableCell as="th">Cheat</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <SetDetails 
                        currentExercise = {currentExercise}
                        updateExercise = {update}
                    />
                </TableBody>
            </Table>
            <Flex justifyContent="center">
                <Button
                    onClick={() => {
                        setMustSave(true); 
                        setMustClose(true);
                    }}
                    style={{ marginLeft: '20px' }}
                >
                    Submit
                </Button>
            </Flex>
        </Flex>
    );
}
